import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "button",
  tabindex: "0",
  class: "text-reset text-decoration-none ms-1",
  style: {"cursor":"pointer"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#citesModal",
  "aria-label": "About CITES-protected woods"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-info" })
  ]))
}